import { MessageCircle } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { whatsappLink } from "@/lib/contact";

export default function WhatsAppFloat() {
  const settings = useSettings();
  return (
    <a
      href={whatsappLink(settings)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp ile yazın"
      className="fixed bottom-24 right-4 z-40 hidden h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:scale-110 lg:flex"
    >
      <MessageCircle className="h-7 w-7" />
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
    </a>
  );
}
